// © Microsoft Corporation. All rights reserved.

import { DesignSystem, accentFillRest, isDarkMode, neutralFillToggleHover, neutralForegroundHint, neutralForegroundRest, neutralLayerCard } from "@microsoft/fast-components-styles-msft";

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";
import { profileHrColor } from "../../utils/commonJssConstants";

export const PublisherProfileTabsStyles = (config: DesignSystem) => ({
    publisherProfileTabsContainer: {
        "min-width": "320px",
        margin: "3px 3px 16px",
        "background-color": neutralLayerCard,
        "border-radius": "2px",
        "box-shadow": "0px 0px 2.9px rgba(0, 0, 0, 0.11), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13)",

        "& .cwt-publisher-profile-tabs": {
            position: "sticky",
            top: "0px",
            "z-index": "5",
            margin: "0",
            padding: "0 18px",
            background: neutralLayerCard,
            "border-bottom": "1px solid ",
            "border-color": profileHrColor, // No fast Color available
            "overflow-x": "scroll",
            "list-style": "none",

            "&.disabled": {
                "pointer-events": "none"
            },

            // 'Hide scrollbar'
            "-ms-overflow-style": "none",

            "&::-webkit-scrollbar": {
                display: "none"
            },

            "& .cwt-tab-item": {
                position: "relative",
                padding: "15px 10px",
                color: neutralFillToggleHover,

                "&:first-child": {
                    [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "0"
                },

                "&.active": {
                    color: isDarkMode(config) ? "#5CB6FF" : accentFillRest,
                    "font-weight": "600",

                    "&:after": {
                        position: "absolute",
                        "z-index": "10",
                        content: "' '",
                        height: "3px",
                        width: "100%",
                        "margin-top": "calc(15px - 3px)",
                        [applyLocalizedProperty("left", "right", config.direction)]: "0",
                        background: accentFillRest
                    },

                    "& .cwt-icon-label": {
                        color: isDarkMode(config) ? "#5CB6FF" : accentFillRest
                    }
                },

                "& .cwt-icon": {
                    color: "inherit",
                    "white-space": "nowrap",
                    height: "18px",
                    [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "4px"
                },

                "& .cwt-icon-label": {
                    color: neutralForegroundRest,
                    "font-size": "13px",

                    "&:before": {
                        display: "inline-block",
                        content: "' '",
                        width: "4px"
                    }
                }
            }
        },

        "& .cwt-sortbox-container": {
            margin: "10px 18px 5px",
            display: "flex",
            "justify-content": "flex-end",
            "& .cwt-sort-value": {
                "font-weight": "normal",
                color: neutralForegroundHint
            }
        },

        "& .cwt-tab-content": {
            position: "relative",
            display: "flex",
            "flex-wrap": "wrap",
            "min-height": "60vh",
            padding: "0px 12px 10px",

            "& > div": {
                margin: "10px"
            }
        }
    }
});